/**
 * General functions
 */
export default function main ($) {

     // add accesiblity to divs. This function allows the enter key to activate the elements click function when focused upon

    document.onkeydown = function(e) {
    if(e.keyCode === 13) { // The Enter/Return key
        document.activeElement.click();
    }
    };


    if ($("body").hasClass("single")) {

        var socialMenu = $(".social-share-hidden");

        $(window).scroll(function() {
            var documentHeight = $(document).height();

            var scroll = $(window).scrollTop();
            if (scroll > 1 && (scroll <= (documentHeight - 1700))){
                socialMenu.removeClass('social-share-hidden').addClass('social-share-visible')

            }else{
                socialMenu.removeClass('social-share-visible').addClass('social-share-hidden')

            }
    
        });
    }

    if ($('body').hasClass('blog') || $('body').hasClass('archive')) {
       
        $('select').on('change', function() {
            var url = $(this).val();
            if (url) {
                window.location = url;
            }
            return false;
        });
    }

    function handleFirstTab(e) {
        if (e.keyCode === 9) { // the "I am a keyboard user" key
        console.log('user is tabbing')
            document.body.classList.add('user-is-tabbing');
            window.removeEventListener('keydown', handleFirstTab);
        }
    }
    
    window.addEventListener('keydown', handleFirstTab);

  
 
    


    

}


